import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './_view-card.scss'; // Criaremos este arquivo SCSS a seguir

interface ViewCardProps {
  title: string;
  description?: string;
  icon?: React.ReactNode; // Para um ícone visual
  routePath: string;
  backgroundColor?: string; // Cor de fundo do card
  textColor?: string;       // Cor do texto do card
  className?: string;       // Classes adicionais para estilização
}

export function ViewCard({
  title,
  description,
  icon,
  routePath,
  backgroundColor = '#007bff', // Cor padrão (azul Bootstrap)
  textColor = '#ffffff',       // Cor padrão do texto (branco)
  className = '',
}: ViewCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(routePath);
  };

  return (
    <motion.div
      className={`view-card card h-100 ${className}`}
      style={{ backgroundColor, color: textColor }}
      onClick={handleClick}
      whileHover={{ scale: 1.03, y: -5 }}
      whileTap={{ scale: 0.98 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
    >
      <div className="card-body text-center d-flex flex-column justify-content-center align-items-center p-4">
        {icon && <div className="view-card-icon mb-3">{icon}</div>}
        <h5 className="card-title mb-2">{title}</h5>
        {description && <p className="card-text small">{description}</p>}
      </div>
    </motion.div>
  );
}
